import { makeStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import PropTypes from 'prop-types';
import Tooltip from './Tooltip';

const useStyles = makeStyles({
  label: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
  },
  icon: {
    fontSize: 16,
    cursor: 'help',
  },
});

const LabelWithInfo = ({ label, tooltip, testId }) => {
  const classes = useStyles();

  return (
    <span className={classes.label}>
      {label}
      <Tooltip arrow placement="top" title={tooltip}>
        <InfoOutlinedIcon data-testid={testId} className={classes.icon} role="img" tabIndex={0} aria-label={tooltip} />
      </Tooltip>
    </span>
  );
};

LabelWithInfo.propTypes = {
  label: PropTypes.node.isRequired,
  tooltip: PropTypes.node.isRequired,
  testId: PropTypes.string.isRequired,
};

export default LabelWithInfo;
